import React from "react";
import classNames from "classnames";
import {connect} from "react-redux";
import {Tooltip} from "@material-ui/core";

import {
  removeSearchResultDetailsAction,
  storeSearchResultDetailsAction,
} from "../../../state/application/actions"
import {
  openSearchResultDetailsDispatchAction,
  updateSelectedProductsDispatchAction
} from "../../../state/product/dispatchActions";
import {
  getSearchFormValuesByState,
} from "../../../helpers/configurationHelper";
import {
  getInterferometricStackSearchResultColumns,
} from "../../../helpers/productHelper";
import {
  InterferometricStackType,
  ProductImageStacType,
  SearchResultElementType,
  SearchResultsType
} from "../../../types/product";
import {ConfigurationsType} from "../../../types/configurations";
import InputCheckbox from "../inputs/InputCheckbox";

import SearchResultDataProperties from "./shared/SearchResultDataProperties";
import {
  getInterferometricStackIdentifierFrom, getInterferometricStackItemsCount,
  getInterferometricStackItemsSelectedCount, isInterferometricStackSelected
} from "../../../helpers/interferometricStackHelper";
import {
  isInterferometricStackSearchResultElement,
  isInterferometricStackSearchResults
} from "../../../helpers/searchResultsHelper";
import {ShapeType} from "../../../types/shape";
import {
  getAllQuicklookPreviewsFromProductImages,
  toggleQuicklookPreviewFrom
} from "../../../helpers/quicklookPreviewHelper";
import {QuicklookPreviewType} from "../../../types/geoMap";
import {updateQuicklookPreviewsAction} from "../../../state/geoMap/actions";
import {AllQuicklookPreviewsType} from "../../../state/geoMap/types";
import {DEFAULT_TOOLTIP_PROPS} from "../../../helpers/tooltipHelper";
import translations from '../../../translations';

interface PropsType {
  searchResultID: string,
  stack: InterferometricStackType,
  configurations: ConfigurationsType,
  searchFormValues: any,
  selectedProducts: ProductImageStacType[],
  isListViewActive: boolean,
  searchResultDetails: InterferometricStackType,
  storeSearchResultDetailsActionHandler: (item: SearchResultElementType) => {},
  removeSearchResultDetailsActionHandler: () => {},
  openSearchResultDetailsActionHandler: any,
  searchResults: SearchResultsType,
  selectedArea: ShapeType,
  allQuicklookPreviews: AllQuicklookPreviewsType,
  updateQuicklookPreviewsActionHandler: any,
  updateSelectedProductsActionHandler: (
    configurations: ConfigurationsType,
    searchFormValues: any,
    selectedArea: ShapeType,
    isInterferometricStackSearch: boolean,
    items:ProductImageStacType[],
    isChecked: boolean,
    language: string
  ) => {},
  language: string
}

const InterferometricStack = (props: PropsType) => {
  const {
    searchResultID,
    stack,
    isListViewActive,
    storeSearchResultDetailsActionHandler,
    removeSearchResultDetailsActionHandler,
    openSearchResultDetailsActionHandler,
    updateSelectedProductsActionHandler,
    selectedProducts,
    searchResultDetails,
    configurations,
    searchFormValues,
    selectedArea,
    searchResults,
    allQuicklookPreviews,
    updateQuicklookPreviewsActionHandler,
    language
  } = props;

  const isInterferometricStackSearch = isInterferometricStackSearchResults(searchResults);
  const stackItemsSelectedCount = getInterferometricStackItemsSelectedCount(stack, selectedProducts);
  const isStackSelected = isInterferometricStackSelected(stack, selectedProducts);
  const stackItemsCount = getInterferometricStackItemsCount(stack);
  const isShowProductDetailsButtonEnabled = true;
  const isCenteringButtonEnabled = true;

  const hasFocusSelected = searchResultDetails && isInterferometricStackSearchResultElement(searchResultDetails) &&
    getInterferometricStackIdentifierFrom(searchResultDetails) === getInterferometricStackIdentifierFrom(stack);

  return (
    <div
      key={`interferometric-stack-${searchResultID}`}
      className={classNames("search-result", {
        "col-12 list-view": isListViewActive,
        "col-6 matrix-view": !isListViewActive
      })}
    >
      <div className="position-relative d-flex inner-wrapper">
        <div className="wrapper-select-search-result-checkbox">
          <InputCheckbox
            name={`imgCheckbox_${searchResultID}`}
            checked={isStackSelected}
            tooltip={(isStackSelected && translations('deselectThisStack', language)) || translations('selectThisStack', language)}
            onChange={(e) => {
              const isSelected = e.target.checked;
              updateSelectedProductsActionHandler(configurations, searchFormValues, selectedArea, isInterferometricStackSearch, stack.items, isSelected, language);
              if (!isSelected) {
                const allQuicklook = getAllQuicklookPreviewsFromProductImages(allQuicklookPreviews, stack.items)
                  .map((quicklookPreview: QuicklookPreviewType) => toggleQuicklookPreviewFrom(quicklookPreview, false))
                updateQuicklookPreviewsActionHandler(allQuicklook)

                if (hasFocusSelected) {
                  removeSearchResultDetailsActionHandler();
                }
              }
            }}
            disabled={false}
            checkboxClassName={classNames({
              "full-selection": stackItemsCount === stackItemsSelectedCount,
              "some-selection": stackItemsSelectedCount > 0 && stackItemsSelectedCount < stackItemsCount
            })}
          />
          <span className="select-search-results-ratio">
            {stackItemsSelectedCount}/{stackItemsCount}
          </span>
        </div>
        <div className="search-result-data">
          <SearchResultDataProperties
            properties={getInterferometricStackSearchResultColumns(configurations, stack, language)}
            isListViewActive={isListViewActive}
          />
          <div className="product-action-buttons-container">
            <Tooltip {...DEFAULT_TOOLTIP_PROPS}
              title="Details"
              placement="top"
            >
              <span>
                <button
                  type="button"
                  className="remove-btn-defaults"
                  disabled={!isShowProductDetailsButtonEnabled}
                  style={!isShowProductDetailsButtonEnabled ? {pointerEvents: "none"} : {}}
                  onClick={() => openSearchResultDetailsActionHandler(stack)}
                >
                  <svg><use xlinkHref="#product-list-icon" fill="#ffffff"/></svg>
                </button>
              </span>
            </Tooltip>
            <Tooltip {...DEFAULT_TOOLTIP_PROPS}
              title={translations('centeringProduct',language)}
              placement="top"
            >
              <span>
                <button
                  type="button"
                  className={classNames("focus-button remove-btn-defaults", {
                    selected: hasFocusSelected
                  })}
                  style={!isCenteringButtonEnabled ? {pointerEvents: "none"} : {}}
                  disabled={!isCenteringButtonEnabled}
                  onClick={() => {
                    if (!isStackSelected) {
                      updateSelectedProductsActionHandler(configurations, searchFormValues, selectedArea, isInterferometricStackSearch, stack.items, true, language);
                    }
                    if (hasFocusSelected) {
                      removeSearchResultDetailsActionHandler();
                    } else {
                      storeSearchResultDetailsActionHandler(stack);
                    }
                  }}
                >
                  <svg><use xlinkHref="#targer-icon" fill="#ffffff"/></svg>
                </button>
              </span>
            </Tooltip>
          </div>

        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (state) => ({
  isListViewActive: state.product.isListViewActive,
  selectedProducts: state.product.selectedProducts,
  tabActiveInLeftSidebar: state.application.tabActiveInLeftSidebar,
  configurations: state.application.configurations,
  searchFormValues: getSearchFormValuesByState(state),
  searchResultDetails: state.application.searchResultDetails,
  searchResults: state.product.searchResults,
  selectedArea: state.geoMap.lastShape,
  allQuicklookPreviews: state.geoMap.allQuicklookPreviews,
  language: state.application.appParameters.language
});

const mapDispatchToProps = (dispatch) => ({
  storeSearchResultDetailsActionHandler: (item) => dispatch(storeSearchResultDetailsAction(item)),
  openSearchResultDetailsActionHandler: (item) => dispatch(openSearchResultDetailsDispatchAction(item)),
  removeSearchResultDetailsActionHandler: () => dispatch(removeSearchResultDetailsAction()),
  updateSelectedProductsActionHandler: (configurations, searchFormValues, selectedArea, isInterferometricStackSearch, products, add, language) => dispatch(updateSelectedProductsDispatchAction(configurations, searchFormValues, selectedArea, isInterferometricStackSearch, products, add, language)),
  updateQuicklookPreviewsActionHandler: (quicklookPreviews) => dispatch(updateQuicklookPreviewsAction(quicklookPreviews)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InterferometricStack)
